function statusLabel(status) {
  if (status === 'enabled') return 'Enabled';
  if (status === 'disabled') return 'Provisioned / disabled';
  return 'Not provisioned';
}

export default function AdminSecurityStatus({ security = {}, editing = false }) {
  const hcStatus = security.hcRoleSynchronizationStatus
    || (security.dedicatedRoleWriterConfigured ? 'disabled' : 'not_provisioned');
  const genericStatus = security.genericRoleManagementStatus
    || (security.dedicatedGenericRoleWriterConfigured ? 'disabled' : 'not_provisioned');

  return <section className="admin-settings-panel">
    <div className="admin-section-heading"><span>05</span><div><h4>Security status</h4><small>Live API protection and role-writer state. The browser edit-session lock is shown separately.</small></div></div>
    <div className="admin-settings-grid single-column">
      <section className="admin-settings-card">
        <div className="admin-security-row"><span>Outlook actions</span><strong>{security.outlookActionsEnabled ? 'Enabled' : 'Disabled'}</strong></div>
        <div className="admin-security-row"><span>Pilot restriction</span><strong>{security.pilotRestrictionEnabled ? 'Enabled' : 'Disabled'}</strong></div>
        <div className="admin-security-row"><span>Dedicated admin settings writer</span><strong>{security.dedicatedAdminWriterConfigured ? 'Configured' : 'Not configured'}</strong></div>
        <div className="admin-security-row"><span>Admin setting writes (API)</span><strong>{security.adminWritesEnabled ? 'Enabled' : 'Locked'}</strong></div>
        <div className="admin-security-row"><span>HC Role Writer</span><strong>{statusLabel(hcStatus)}</strong></div>
        <div className="admin-security-row"><span>HC automatic role sync</span><strong>{hcStatus === 'enabled' && security.adminWritesEnabled ? 'Enabled' : 'Locked'}</strong></div>
        <div className="admin-security-row"><span>Generic Role Writer</span><strong>{statusLabel(genericStatus)}</strong></div>
        <div className="admin-security-row"><span>Generic role changes</span><strong>{genericStatus === 'enabled' && security.adminWritesEnabled ? 'Enabled' : 'Locked'}</strong></div>
        <div className="admin-security-row"><span>Admin browser edit session</span><strong>{editing ? 'Enabled' : 'Locked'}</strong></div>
        <div className="admin-security-row"><span>Runtime IDs</span><strong>Read only</strong></div>
        <div className="admin-security-row"><span>Worker / Gate controls</span><strong>Not editable here</strong></div>
      </section>
    </div>
    <div className="admin-settings-footer">
      <strong>Role-writer status comes from the live API configuration; locking the browser edit session does not disable a provisioned writer.</strong>
    </div>
  </section>;
}
